import React from 'react'
import {getNationalityFlag, getNationalityKoreanName, Nationality} from "./types/Nationality";
import styled from 'styled-components';
import ColSpacer from "./styles/ColSpacer";

const NationalityBadge: React.FC<{nationality: Nationality}> = ({nationality}) => {
    return (
        <Badge>
            <Flag>{getNationalityFlag(nationality)}</Flag>

            <ColSpacer size={3}/>

            <span className={'d-none d-md-block'}>
                <Name>{getNationalityKoreanName(nationality)}</Name>
            </span>
        </Badge>
    )
}

const Badge = styled.span.attrs({
    className: 'force-1-line'
})`
    display: flex;
`

const Flag = styled.span`
    font-size: 1.3rem;
    line-height: 1;
    padding-top: 3px;
`

const Name = styled.span`
    font-size: 1.0rem;
    color: var(--text-color);
`

export default NationalityBadge
